export const API = {
  categories: "categories",
  products: (categoryId: number) => `categories/${categoryId}/products`,
  productDetail: (productId: number) =>
    `/products/groupedProducts/${productId}`,
  articleDetail: (articleId: number) => `api/article/${articleId}`,
  search: "api/search",
  location: (zipCode: string) => `locations/postalCode/${zipCode}`,
  price: (userId: number, locationId: number, skus: string) =>
    `api/orders-prices?userId=${userId}&locationId=${locationId}&skus=${skus}`,
  mapsAPI: (postalCode: number, country: string) =>
    `https://maps.googleapis.com/maps/api/geocode/json?skip_auth&components=postal_code:${postalCode}|country:${country}&region=AU&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
  openPayfillOrder: () => `api/orders/createOrder`,
  _3dSecureTokenUrl: () => `api/orders/3dSecurePaymentToken`,
  sendEmail: () => `/notify`,
};

export type ZipCodeLocation = {
  countryName: string;
  location: Location;
};

export type Location = {
  cityId: string;
  city: string;
  stateId: string;
  state: string;
  neighborhood: Neighborhood[];
};

export type Neighborhood = {
  value: string;
  label: string;
};

export type LocationCoordinates = {
  lat: number;
  lng: number;
};

export type CodePostalInfo = {
  results: Array<any>;
  status: string;
};

interface LooseObject {
  [key: string]: any;
}

export type Email = {
  sendgrid: {
    from_email: string;
    to_email: string;
    subject: string;
    message: string;
    mailSettings?: LooseObject;
  };
};
